// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3guxQ","type":"styles_type__U6HJU","choices":"styles_choices__2Ecin"};